import { useMediaQuery } from "react-responsive";

export const IsMobile = () => {
    const _isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const _isMobileDevice = useMediaQuery({ query: '(max-device-width: 768px)' });

    return _isMobile || _isMobileDevice ? true : false;
}